import cx from 'classnames';
import { ReactNode } from 'react';

import CheckBoxIcon from '@material-ui/icons/CheckBox';

import styles from './TickList.module.scss';

interface TickListProps {
  items: ReactNode[];
  variant?: 'default' | 'small';
}

export const TickList = ({ items, variant }: TickListProps) => (
  <div className={cx(styles.container, variant === 'small' && styles.container_small)}>
    {items.map((item, i) => (
      <div key={i} className={styles.listItem}>
        <CheckBoxIcon className={styles.checkIcon} />
        <p>{item}</p>
      </div>
    ))}
  </div>
);
